<template>
    <div id="top-bar" class="top-bar">
        <div class="container">
            <div class="row">
                <div class="col-md-8 w-auto col-xs-12">
                    <div class="ts-date d-none d-sm-inline">
                        <i class="fa fa-calendar-check-o"></i>{{ new Date() | formatShortDate }}
                    </div>
                    <ul class="unstyled top-nav">
                        <li><a href="/jogi-nyilatkozat">Jogi nyilatkozat</a></li>
                        <li><a href="https://play.google.com/store/apps/details?id=ma.szekelyfold.dws.com.szekelyfoldma" class="d-none d-sm-block">Android verzió</a></li>
                        <li><a href="/kapcsolat">Kapcsolat</a></li>
                    </ul>
                </div><!--/ Top bar left end -->

                <div class="col-md-4 top-social text-lg-right text-md-center w-auto">
                    <ul class="unstyled">
                        <li>
                            <a title="Facebook" href="https://www.facebook.com/Szekelyfold.ma">
                                <span class="social-icon"><i class="fab fa-facebook-f"></i></span>
                            </a>
                            <a title="Twitter" href="#" class="d-none">
                                <span class="social-icon"><i class="fab fa-twitter"></i></span>
                            </a>
                            <a title="Rss" href="#" class="d-none">
                                <span class="social-icon"><i class="fa fa-rss"></i></span>
                            </a>
                        </li>
                    </ul><!-- Ul end -->
                </div><!--/ Top social col end -->
            </div><!--/ Content row end -->
        </div><!--/ Container end -->
    </div>
</template>

<script>
    export default {
        name: 'TopBar',
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    .top-bar {
        padding: 8px 0;
        border-bottom: 1px solid #dedede;
        color: #a3a3a3;
        font-size: 13px;
        height: 40px;

        .ts-date {
            display: inline-block;
            border-right: 1px solid #acacac;
            padding-right: 10px;
            line-height: 12px;
        }

        .unstyled {
            list-style: none;
            margin: 0;
            padding: 0;
        }

        .top-nav {
            display: inline-block;

            li {

                @media (max-width: 576px) {
                    padding-left: 2px !important;
                }

                display: inline-block;
                line-height: 12px;
                padding-left: 12px;

                a {
                    background: none;
                    color: #a3a3a3;
                    padding: 0;
                    line-height: 100%;
                }
            }

            li a:hover {
                color: $red;
                text-decoration: none;
            }
        }

        .top-social {
            li {

                // Small devices (landscape phones, 576px and up)
                @media (max-width: 576px) {
                    a {
                        margin-right: 4px !important;
                    }
                }

                a {
                    color: #a3a3a3;
                    margin-right: 15px;
                    font-size: 14px;
                    -webkit-transition: 400ms;
                    -moz-transition: 400ms;
                    -o-transition: 400ms;
                    transition: 400ms;
                }
            }

            li a:hover {
                color: $dark-grey;
            }

            .social-icon {
                list-style: none;
                margin: 0;
                padding: 0;
            }
        }
    }
</style>